module.exports = __webpack_public_path__ + "static/media/po-undercarriage-1.8740928f.png";